import { createSlice } from '@reduxjs/toolkit';
import ApiClientConnector from 'src/api/ApiClientConnector';

const initialState = {
    searchCriteria: {
        destination: null,
        checkIn: null,
        checkOut: null,
    },
    paxData: [{ adults: 2, children: 0, childrenAges: [] }],
    maxAdult: 4,
    maxChildren: 4,
    services: [],
    searchRequestId: 0
};

export const SearchServiceSlice = createSlice({
    name: 'searchServices',
    initialState,
    reducers: {
        setServiceSearchCriteria: (state, action) => {
            state.searchCriteria = { ...state.searchCriteria, ...action.payload };
        },
        clearSearchSServiceSliceCriteria: (state) => {
            state.searchCriteria = initialState.searchCriteria;
        },
        updatePaxData: (state, action) => {
            state.paxData = action.payload;
        },
        updateAdultsCount: (state, action) => {
            const { index, count } = action.payload;
            if (state.paxData[index]) {
                state.paxData[index].adults = count;
            }
        },
        updateChildrenCount: (state, action) => {
            const { index, count } = action.payload;
            const pax = state.paxData[index];

            if (pax) {
                pax.children = count;

                if (count > pax.childrenAges.length) {
                    pax.childrenAges = [...pax.childrenAges, ...Array(count - pax.childrenAges.length).fill(0)];
                } else {
                    pax.childrenAges = pax.childrenAges.slice(0, count);
                }
            }
        },
        updateChildrenAges: (state, action) => {
            const { index, childIndex, age } = action.payload;
            const pax = state.paxData[index];

            if (pax && pax.childrenAges[childIndex] !== undefined) {
                pax.childrenAges[childIndex] = age;
            }
        },
        setWedding: (state, action) => {
            state.wedding = action.payload;
        },
        setHoneymoon: (state, action) => {
            state.honeymoon = action.payload;
        },
        setMaxAdult: (state, action) => {
            state.maxAdult = action.payload;
        },
        setMaxChildren: (state, action) => {
            state.maxChildren = action.payload;
        },
        paxIncrement: (state, action) => {
            const { index, type } = action.payload;
            const pax = state.paxData[index];

            if (type === 'adults' && pax.adults < state.maxAdult) {
                pax.adults += 1;
            } else if (type === 'children' && pax.children < state.maxChildren) {
                pax.children += 1;
                pax.childrenAges.push(0);
            }
        },

        paxDecrement: (state, action) => {
            const { index, type } = action.payload;
            const pax = state.paxData[index];

            if (type === 'adults' && pax.adults > 1) {
                pax.adults -= 1;
            } else if (type === 'children' && pax.children > 0) {
                pax.children -= 1;
                pax.childrenAges.pop();
            }
        },
        getServiceResultList: (state, action) => {
            state.services = action.payload;
        },
        incrementSearchRequestId: (state) => {
            state.searchRequestId += 1;
        },
    },
});

export const fetchServices = (instance, accounts, criteria) => async (dispatch) => {
    dispatch(incrementSearchRequestId());
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.post(criteria);
    const serviceArray = result.Results || [];
    dispatch(getServiceResultList(serviceArray));
    return result;
};

export const {
    setServiceSearchCriteria,
    clearSearchSServiceSliceCriteria,
    updatePaxData,
    updateAdultsCount,
    updateChildrenCount,
    updateChildrenAges,
    setMaxAdult,
    setMaxChildren,
    paxIncrement,
    paxDecrement,
    getServiceResultList,
    incrementSearchRequestId
} = SearchServiceSlice.actions;

export default SearchServiceSlice.reducer;